import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { USER_TABS } from './users.paths';

export const USER_ROUTES: RouteObject[] = [
  { path: 'users', element: <UsersPage /> },
  ...recordTabRoutes('users/:id', USER_TABS, (tab) => <UserDetailPage tab={tab} />),
];
